const r = (e) => {
  if (!e)
    return "Field is required";
};
export {
  r as validateField
};
//# sourceMappingURL=Input.validation.es.js.map
